export default "__VITE_ASSET__h0dcjx_P__"